export default __webpack_public_path__ + "static/media/detail_main_img_12.93eb047d.png";